/**
 * Splits a camelCase, snake_case, kebab-case, or dotted column key into
 * lowercase word tokens: "borrowerId" -> ["borrower", "id"], "apiVersion"
 * -> ["api", "version"], "company_id" -> ["company", "id"].
 *
 * Also splits an acronym run from an immediately-following capitalized
 * word — "sftpSSHPeachPrivateKey" -> [..., "ssh", "peach", ...],
 * "isCreateAndSendPDF" -> [..., "pdf"] — since real backend field names put
 * multi-letter acronyms directly against the next PascalCase word. The
 * lookahead requires at least 2 lowercase letters after the second
 * capital, not 1, so a lone trailing pluralizing "s" after an acronym
 * (e.g. "whitelistedIPs") stays part of that acronym's token ("ips")
 * instead of being misread as the start of a new one-letter word.
 */
export const tokenizeColumnKey = (columnKey: string): Array<string> =>
  columnKey
    .replace(/([a-z0-9])([A-Z])/g, '$1 $2')
    .replace(/([A-Z]+)([A-Z][a-z]{2,})/g, '$1 $2')
    .split(/[^a-zA-Z0-9]+/)
    .filter(Boolean)
    .map((word) => word.toLowerCase())
